@if (!isHidden) {
    @if (dataSourceState$ | async; as dataSourceState) {
        @if (dataSourceState.loading) {
            {{ 'LOADING.DATA_SOURCE' | delayDisplay | translate }}
        } @else {
            <mat-radio-group
                class="ca-slot-tile-radio-group w-full"
                [caLayout]="slot().layout"
                [attr.aria-label]="ariaLabel()"
                [value]="value()"
                [formControl]="control"
                [disabled]="!!isDisabled"
                (change)="onValueChange($event.value)"
                (blur)="onTouched()"
            >
                @for (item of dataSourceMapping || dataSourceState.dataSource.items; track item.value) {
                    @let tooltip = slot() | slotTooltip: item.value;
                    <div class="relative">
                        <mat-radio-button
                            [disableRipple]="true"
                            [value]="item.value"
                            class="ca-no-border-radio ca-radio-tile-with-visual"
                            [ngClass]="{ 'ca-radio-tile-with-tooltip': tooltip }"
                        >
                            @let slotTitle = slot().titleKey | translationKey: slot().titleData : item.value;
                            <div class="ca-radio-label-text w-full flex items-center gap-2 pr-2">
                                <span class="flex-grow">{{ slotTitle }}</span>
                                @if (tooltip) {
                                    <ca-visual [tooltip]="tooltip"></ca-visual>
                                }
                            </div>
                            @if (isVisual) {
                                <div class="ca-radio-visual-container">
                                    <ca-visual [slot]="slot()" [value]="item.value"></ca-visual>
                                </div>
                            }
                        </mat-radio-button>
                    </div>
                }
            </mat-radio-group>
            @if (isErrorMessage) {
                <div class="ca-subscript relative">
                    <div class="absolute ca-error-message" @slideDown>
                        <ca-form-error-message>
                            {{ errorMessageTranslation!.key | translationKey: errorMessageTranslation!.data }}
                        </ca-form-error-message>
                    </div>
                </div>
            }
        }
    }
}
